export const getters = {
  systemFuels: state => state.fuels,
  fuelitemsRows: state => state.fuel_item
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/fuels/getters.js